import React, { useEffect } from 'react';
import styled from 'styled-components';

import FAQsActions from '../actions/faqs';

import ExpandableCopy from './ExpandableCopy';
import VendorProfileSection from './VendorProfileSection';
import { useDispatch, useSelector } from 'react-redux';

const Wrapper = styled.div`
  margin-bottom: 28px;
  width: 100%;
`;

const QuestionText = styled.h4`
  margin: 8px 0 0.5em 0;
`;

const AnswerText = styled.div`
  color: #666;
  font-size: 0.85em;
  margin-bottom: 0.85em;
`;

export default function Questions({ vendorId, userId }) {
  const dispatch = useDispatch();
  const allFAQs = useSelector(state => state.faqs);

  const isFetching = allFAQs.is_fetching;
  const questions = Object.values(allFAQs[vendorId] ?? {});

  useEffect(() => {
    dispatch(FAQsActions.fetchFAQs(vendorId));
  }, []);

  if (!isFetching && questions?.length < 1) {
    return null;
  }

  return (
    <VendorProfileSection title="Questions + Answers">
      {!isFetching && (
        <div>
          {questions?.map((o, index) => (
            <Wrapper key={index}>
              <QuestionText>{o.question}</QuestionText>
              <AnswerText>
                <ExpandableCopy ignore={o.answer.length < 150}>
                  {o.answer}
                </ExpandableCopy>
              </AnswerText>
            </Wrapper>
          ))}
        </div>
      )}
    </VendorProfileSection>
  );
}
